import type { PostAccess, PostType, VideoPostType } from '../../types'

export type PollLength = {
  days: string
  hours: string
  minutes: string
}

export type Image = { image: string; id: number }

export enum FormFields {
  mode = 'mode',
  liveAt = 'liveAt',
  access = 'access',
  postType = 'postType',
  title = 'title',
  description = 'description',
  notifyMembers = 'notifyMembers',
  image = 'image',
  images = 'images',
  videoType = 'videoType',
  video = 'video',
  videoThumbnail = 'videoThumbnail',
  videoSubtitles = 'videoSubtitles',
  videoUrl = 'videoUrl',
  videoSeries = 'videoSeries',
  audio = 'audio',
  audioThumbnail = 'audioThumbnail',
  pollOptions = 'pollOptions',
  pollLength = 'pollLength',
  tags = 'tags',
  tierIds = 'tierIds',
  liveStreamResourceId = 'liveStreamResourceId',
  liveStreamStartDate = 'liveStreamStartDate',
}

export type FormValues = {
  [FormFields.mode]?: 'update' | 'create'
  [FormFields.liveAt]?: Date
  [FormFields.access]: PostAccess
  [FormFields.postType]?: PostType
  [FormFields.title]: string
  [FormFields.description]?: string
  [FormFields.notifyMembers]?: boolean
  [FormFields.image]?: File | string
  [FormFields.images]: Image[]
  [FormFields.videoType]: VideoPostType
  [FormFields.video]?: File | string
  [FormFields.videoThumbnail]?: File | string
  [FormFields.videoSubtitles]?: File | boolean
  [FormFields.videoUrl]?: string
  [FormFields.videoSeries]?: { id: number }[]
  [FormFields.audio]?: File | string
  [FormFields.audioThumbnail]?: File | string
  [FormFields.pollOptions]?: string[]
  [FormFields.pollLength]?: PollLength
  [FormFields.tags]: string[]
  [FormFields.tierIds]: Record<string, boolean>
  [FormFields.liveStreamResourceId]?: number
  [FormFields.liveStreamStartDate]?: string
}
